import { ButtonToggleGroup, ButtonToggleGroupItem } from '@shiftfinancial/design-system';
import type { FieldProps } from 'formik';

import FormikField from './FormikField';

type Option = { id: string; text: string };

type FormikButtonSelectFieldProps = FieldProps & {
  onSelectionChange?: (option: Option) => void;
  options: Option[];
  value?: string;
};

function FormikButtonSelectField({
  field,
  form,
  onSelectionChange,
  options,
  value,
}: FormikButtonSelectFieldProps) {
  return (
    <FormikField field={field} form={form}>
      <ButtonToggleGroup
        value={value}
        onValueChange={(value) => {
          const option = options.find((x) => x.id === value)!;
          form.setFieldValue(field.name, value, true);
          onSelectionChange?.(option);
        }}
      >
        {options?.map((option) => (
          <ButtonToggleGroupItem
            key={option.id}
            value={option.id}
            data-testid={
              option.text?.replace(/["']/g, '').toLowerCase().split(' ').join('-') ?? undefined
            }
          >
            {option.text}
          </ButtonToggleGroupItem>
        ))}
      </ButtonToggleGroup>
    </FormikField>
  );
}

export default FormikButtonSelectField;
